document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

function initHeaderSearch() {
	const searchToggle = document.querySelector('[data-scie-search-toggle]');
	const searchPanel = document.getElementById('scie-header-search');
	const searchInput = document.getElementById('scie-header-search-input');

	if (!searchToggle || !searchPanel) {
		return;
	}

	const desktopBreakpoint = window.matchMedia('(min-width: 992px)');

	const setSearchState = (isOpen, shouldFocus = true) => {
		searchPanel.classList.toggle('is-open', isOpen);
		searchPanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
		searchToggle.classList.toggle('is-active', isOpen);
		searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		searchToggle.setAttribute('aria-label', isOpen ? 'Close search' : 'Search the website');

		if (isOpen && shouldFocus && searchInput instanceof HTMLElement) {
			searchInput.focus();
		}

		if (!isOpen) {
			searchPanel.dispatchEvent(new CustomEvent('scie:header-search-closed'));
		}
	};

	searchToggle.addEventListener('click', () => {
		setSearchState(!searchPanel.classList.contains('is-open'));
	});

	document.addEventListener('click', (event) => {
		if (!searchPanel.classList.contains('is-open')) {
			return;
		}

		if (searchPanel.contains(event.target) || searchToggle.contains(event.target)) {
			return;
		}

		setSearchState(false, false);
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && searchPanel.classList.contains('is-open')) {
			setSearchState(false, false);
			searchToggle.focus();
		}
	});

	const syncSearchBreakpoint = () => {
		if (!desktopBreakpoint.matches && searchPanel.classList.contains('is-open')) {
			setSearchState(false, false);
		}
	};

	if (desktopBreakpoint.addEventListener) {
		desktopBreakpoint.addEventListener('change', syncSearchBreakpoint);
	} else {
		desktopBreakpoint.addListener(syncSearchBreakpoint);
	}
}

function initDesktopMegaMenu() {
	const Collapse = window.bootstrap && window.bootstrap.Collapse;
	const desktopHeader = document.querySelector('[data-scie-desktop-header]');

	if (!Collapse || !desktopHeader) {
		return;
	}

	const closeOpenMenus = () => {
		desktopHeader.querySelectorAll('.header-mega-menu.show').forEach((menu) => {
			Collapse.getOrCreateInstance(menu, { toggle: false }).hide();
		});
	};

	document.addEventListener('click', (event) => {
		if (!(event.target instanceof Element)) {
			return;
		}

		if (event.target.closest('.header-mega-menu') || event.target.closest('.header-nav__button')) {
			return;
		}

		closeOpenMenus();
	});

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Escape') {
			return;
		}

		closeOpenMenus();
	});
}

function initMobileMenu() {
	const Collapse = window.bootstrap && window.bootstrap.Collapse;
	const mobileMenu = document.getElementById('scie-mobile-menu');

	if (!Collapse || !mobileMenu) {
		return;
	}

	const desktopBreakpoint = window.matchMedia('(min-width: 992px)');
	const panels = Array.from(mobileMenu.querySelectorAll('[data-scie-menu-panel]'));
	let menuTrigger = null;

	const getFocusableElements = () => {
		return Array.from(
			mobileMenu.querySelectorAll(
				'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
			)
		).filter((element) => element.getClientRects().length > 0);
	};

	const showPanel = (panelId) => {
		const targetPanel = panels.find((panel) => panel.dataset.scieMenuPanel === panelId);

		if (!targetPanel) {
			return;
		}

		panels.forEach((panel) => {
			const isTarget = panel === targetPanel;

			panel.hidden = !isTarget;
			panel.classList.toggle('is-active', isTarget);
		});

		const firstFocusable = targetPanel.querySelector(
			'button, a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
		);

		if (firstFocusable instanceof HTMLElement) {
			firstFocusable.focus();
		}
	};

	const resetPanels = () => {
		showPanel('root');
	};

	mobileMenu.querySelectorAll('[data-scie-menu-panel-target]').forEach((button) => {
		button.addEventListener('click', () => {
			showPanel(button.dataset.scieMenuPanelTarget);
		});
	});

	mobileMenu.addEventListener('show.bs.collapse', () => {
		menuTrigger = document.activeElement instanceof HTMLElement ? document.activeElement : null;
		mobileMenu.classList.remove('is-closing');
		mobileMenu.classList.add('is-opening');
		mobileMenu.setAttribute('aria-hidden', 'false');
		document.body.classList.add('mobile-menu-open');
	});

	mobileMenu.addEventListener('shown.bs.collapse', () => {
		mobileMenu.classList.remove('is-opening');

		const closeButton = mobileMenu.querySelector('.mobile-menu__close');

		if (closeButton instanceof HTMLElement) {
			closeButton.focus();
		}
	});

	mobileMenu.addEventListener('hide.bs.collapse', () => {
		mobileMenu.classList.remove('is-opening');
		mobileMenu.classList.add('is-closing');
	});

	mobileMenu.addEventListener('hidden.bs.collapse', () => {
		mobileMenu.classList.remove('is-closing');
		mobileMenu.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('mobile-menu-open');
		resetPanels();

		if (menuTrigger instanceof HTMLElement) {
			menuTrigger.focus();
		}
	});

	document.addEventListener('keydown', (event) => {
		if (!mobileMenu.classList.contains('show')) {
			return;
		}

		if (event.key === 'Escape') {
			Collapse.getOrCreateInstance(mobileMenu, { toggle: false }).hide();
			return;
		}

		if (event.key !== 'Tab') {
			return;
		}

		const focusableElements = getFocusableElements();

		if (!focusableElements.length) {
			return;
		}

		const firstElement = focusableElements[0];
		const lastElement = focusableElements[focusableElements.length - 1];

		if (event.shiftKey && document.activeElement === firstElement) {
			event.preventDefault();
			lastElement.focus();
		} else if (!event.shiftKey && document.activeElement === lastElement) {
			event.preventDefault();
			firstElement.focus();
		}
	});

	const syncDesktopState = () => {
		if (desktopBreakpoint.matches && mobileMenu.classList.contains('show')) {
			Collapse.getOrCreateInstance(mobileMenu, { toggle: false }).hide();
		}
	};

	if (desktopBreakpoint.addEventListener) {
		desktopBreakpoint.addEventListener('change', syncDesktopState);
	} else {
		desktopBreakpoint.addListener(syncDesktopState);
	}
}

function initFooterNavigation() {
	// The footer uses Bootstrap Collapse only on mobile. On larger breakpoints the same
	// markup should behave like static navigation, so this keeps Bootstrap's state in
	// sync with the responsive layout instead of relying on CSS alone.
	const Collapse = window.bootstrap && window.bootstrap.Collapse;
	const footerNavigation = document.querySelector('.footer-navigation');

	if (!Collapse || !footerNavigation) {
		return;
	}

	const mobileBreakpoint = window.matchMedia('(max-width: 767.98px)');
	const panels = Array.from(footerNavigation.querySelectorAll('.footer-nav-collapse'));

	if (!panels.length) {
		return;
	}

	const getToggle = (panel) => footerNavigation.querySelector(`[aria-controls="${panel.id}"]`);

	const syncFooterNavigation = () => {
		const isMobile = mobileBreakpoint.matches;

		panels.forEach((panel) => {
			const button = getToggle(panel);

			// Clear any inline transition height left by Bootstrap before changing modes.
			panel.style.height = '';
			panel.classList.remove('collapsing');

			if (!isMobile) {
				// Desktop/tablet shows every footer column and disables the accordion controls.
				panel.classList.add('collapse', 'show');

				if (button) {
					button.classList.remove('collapsed');
					button.disabled = true;
					button.setAttribute('aria-expanded', 'true');
				}

				return;
			}

			// Mobile restores Bootstrap's accordion behaviour and starts each panel closed.
			const collapse = Collapse.getOrCreateInstance(panel, {
				toggle: false,
			});

			if (button) {
				button.disabled = false;
				button.classList.add('collapsed');
				button.setAttribute('aria-expanded', 'false');
			}

			collapse.hide();
		});
	};

	syncFooterNavigation();

	// Re-apply the correct state if the viewport crosses the mobile breakpoint.
	if (mobileBreakpoint.addEventListener) {
		mobileBreakpoint.addEventListener('change', syncFooterNavigation);
	} else {
		mobileBreakpoint.addListener(syncFooterNavigation);
	}
}

/**
 * Position-aware hover effect for .btn-link buttons.
 *
 * The button's `::after` overlay sits at width/height 0, centred via
 * `transform: translate(-50%, -50%)` and positioned via the `--pa-x` / `--pa-y`
 * custom properties. On hover it grows to 300% w/h, expanding outwards from
 * whatever point `top`/`left` resolve to. This script writes those custom
 * properties to the cursor's entry point on mouseenter and its exit point on
 * mouseleave, so the shape grows in / shrinks out from the side the cursor
 * came from.
 *
 * Original jQuery reference: https://codepen.io/kjbrum/pen/wBBLXx
 */
function initPositionAwareButtons() {
	const buttons = document.querySelectorAll('.btn-link:not(.btn-link--text)');
	if (!buttons.length) return;

	buttons.forEach((button) => {
		const updatePosition = (event) => {
			const rect = button.getBoundingClientRect();
			button.style.setProperty('--pa-x', `${event.clientX - rect.left}px`);
			button.style.setProperty('--pa-y', `${event.clientY - rect.top}px`);
		};

		button.addEventListener('mouseenter', updatePosition);
		button.addEventListener('mouseleave', updatePosition);
	});
}

/**
 * Make full Card Grid cards clickable.
 *
 * Only applies inside the four Card Grid block variants (Card Grid, Card Grid
 * Multi, Numbered Card Grid, Steps Card Grid) - see:
 *   blocks/templates/card-grid/template.php
 *   blocks/templates/card-grid-multi/template.php
 *   blocks/templates/card-grid-numbered/template.php
 *   blocks/templates/card-grid-steps/template.php
 * All four share the `.card-grid` class on their block wrapper <section>,
 * which is what scopes this to just those blocks - see the `.card-grid .card`
 * selector below.
 *
 * Rather than faking a single stretched link over the whole card (which would
 * need the CTA button to give up the `position: relative` its hover animation
 * relies on - see initPositionAwareButtons() above), this delegates clicks
 * anywhere on the card to the card's own CTA link (`.btn-link`, added by the
 * button-primary/secondary/text blocks). Keyboard and screen reader users are
 * unaffected: they still reach the CTA - and any other link inside the card -
 * individually and normally, exactly as before. This only adds a convenience
 * for pointer/touch users, and never touches `.btn-link` markup or styles.
 */
function initClickableCardGrids() {
	const cards = document.querySelectorAll('.card-grid .card');
	if (!cards.length) return;

	cards.forEach((card) => {
		// The card's own CTA is the click target. Cards without one (e.g. a
		// "no link" card) are left alone - nothing to navigate to.
		const cta = card.querySelector('.btn-link');
		if (!cta || !cta.getAttribute('href')) return;

		card.style.cursor = 'pointer';

		card.addEventListener('click', (event) => {
			// Let real interactive elements - the CTA itself, or any link/control
			// the editor has added inside the card's content - handle their own
			// click as normal, rather than being intercepted here.
			if (event.target.closest('a, button, input, select, textarea, label')) {
				return;
			}

			// Don't hijack a click that's actually the end of a text-selection drag.
			const selection = window.getSelection();
			if (selection && selection.toString().length > 0) {
				return;
			}

			// Match the CTA's own behaviour: honour target="_blank", and open in a
			// new tab on a ctrl/cmd-click since there's no real link under the
			// cursor here for the browser to do that natively.
			if (cta.target === '_blank' || event.ctrlKey || event.metaKey) {
				window.open(cta.href, '_blank', 'noopener');
			} else {
				window.location.assign(cta.href);
			}
		});
	});
}

/**
 * Highlight the active link in the anchor menu (in-page nav).
 *
 * When an anchor link is clicked, `.active` is moved to it and removed from the
 * previously selected link. Links are matched by `href`, so the desktop list and
 * the mobile dropdown stay in sync when they point at the same block.
 */
function initInPageNavActive() {
	const navLinks = document.querySelectorAll('.in-page-links .anchor-list__item[href^="#"]');

	if (!navLinks.length) {
		return;
	}

	const setActive = (href) => {
		navLinks.forEach((link) => {
			const isActive = link.getAttribute('href') === href;

			link.classList.toggle('active', isActive);

			if (isActive) {
				link.setAttribute('aria-current', 'true');
			} else {
				link.removeAttribute('aria-current');
			}
		});
	};

	navLinks.forEach((link) => {
		link.addEventListener('click', () => {
			setActive(link.getAttribute('href'));
		});
	});
}

function initNewsArchiveFilters() {
	const archiveFeed = document.querySelector('.news-archive-feed[data-news-archive-url]');

	if (!archiveFeed) {
		return;
	}

	const archiveUrl = archiveFeed.dataset.newsArchiveUrl;
	const filterAreas = archiveFeed.querySelectorAll('.post-feed--filter-mob, .post-feed--filter-desk');

	filterAreas.forEach((filterArea) => {
		filterArea.addEventListener('click', (event) => {
			const filterItem = event.target.closest('.js-news-filter-item');

			if (!filterItem) {
				return;
			}

			event.preventDefault();
			event.stopPropagation();

			filterItem.classList.toggle('active');
			filterItem.setAttribute(
				'aria-pressed',
				filterItem.classList.contains('active') ? 'true' : 'false'
			);
		});

		const applyButton = filterArea.querySelector('.js-news-apply-filters');

		if (!applyButton) {
			return;
		}

		applyButton.addEventListener('click', () => {
			const activeItems = filterArea.querySelectorAll('.js-news-filter-item.active');
			const url = new URL(archiveUrl, window.location.origin);

			url.search = '';

			activeItems.forEach((item) => {
				const termSlug = item.dataset.termSlug;

				if (termSlug) {
					url.searchParams.append('news_topics[]', termSlug);
				}
			});

			const modal = filterArea.closest('.modal');

			if (modal && window.bootstrap?.Modal) {
				window.bootstrap.Modal.getOrCreateInstance(modal).hide();
			}

			window.location.assign(url.toString());
		});
	});
}

function initMcaArchiveFilters() {
	const archiveFeed = document.querySelector('.mca-archive-feed[data-mca-archive-url]');

	if (!archiveFeed) {
		return;
	}

	const archiveUrl = archiveFeed.dataset.mcaArchiveUrl;
	const filterAreas = archiveFeed.querySelectorAll('.post-feed--filter-mob, .post-feed--filter-desk');

	filterAreas.forEach((filterArea) => {
		filterArea.addEventListener('click', (event) => {
			const filterItem = event.target.closest('.js-mca-filter-item');

			if (!filterItem) {
				return;
			}

			event.preventDefault();
			event.stopPropagation();

			filterItem.classList.toggle('active');
			filterItem.setAttribute(
				'aria-pressed',
				filterItem.classList.contains('active') ? 'true' : 'false'
			);
		});

		const applyButton = filterArea.querySelector('.js-mca-apply-filters');

		if (!applyButton) {
			return;
		}

		applyButton.addEventListener('click', () => {
			const activeItems = filterArea.querySelectorAll('.js-mca-filter-item.active');
			const url = new URL(archiveUrl, window.location.origin);

			url.search = '';

			activeItems.forEach((item) => {
				const termSlug = item.dataset.termSlug;
				const taxonomy = item.dataset.termTaxonomy;

				if (termSlug && taxonomy) {
					url.searchParams.append(`${taxonomy}[]`, termSlug);
				}
			});

			const modal = filterArea.closest('.modal');

			if (modal && window.bootstrap?.Modal) {
				window.bootstrap.Modal.getOrCreateInstance(modal).hide();
			}

			window.location.assign(url.toString());
		});
	});
}

function initPostArchiveFilters() {
	const archiveFeed = document.querySelector('.post-archive-feed[data-post-archive-url]');

	if (!archiveFeed) {
		return;
	}

	const archiveUrl = archiveFeed.dataset.postArchiveUrl;
	const filterAreas = archiveFeed.querySelectorAll('.post-feed--filter-mob, .post-feed--filter-desk');

	filterAreas.forEach((filterArea) => {
		filterArea.addEventListener('click', (event) => {
			const filterItem = event.target.closest('.js-post-filter-item');

			if (!filterItem) {
				return;
			}

			event.preventDefault();
			event.stopPropagation();

			filterItem.classList.toggle('active');
			filterItem.setAttribute(
				'aria-pressed',
				filterItem.classList.contains('active') ? 'true' : 'false'
			);
		});

		const applyButton = filterArea.querySelector('.js-post-apply-filters');

		if (!applyButton) {
			return;
		}

		applyButton.addEventListener('click', () => {
			const activeItems = filterArea.querySelectorAll('.js-post-filter-item.active');
			const url = new URL(archiveUrl, window.location.origin);

			url.search = '';

			activeItems.forEach((item) => {
				const termSlug = item.dataset.termSlug;

				if (termSlug) {
					url.searchParams.append('post_topics[]', termSlug);
				}
			});

			const modal = filterArea.closest('.modal');

			if (modal && window.bootstrap?.Modal) {
				window.bootstrap.Modal.getOrCreateInstance(modal).hide();
			}

			window.location.assign(url.toString());
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		initHeaderSearch();
		initDesktopMegaMenu();
		initMobileMenu();
		initFooterNavigation();
		initPositionAwareButtons();
		initClickableCardGrids();
		initInPageNavActive();
		initNewsArchiveFilters();
		initMcaArchiveFilters();
		initPostArchiveFilters();
	});
} else {
	initHeaderSearch();
	initDesktopMegaMenu();
	initMobileMenu();
	initFooterNavigation();
	initPositionAwareButtons();
	initClickableCardGrids();
	initInPageNavActive();
	initNewsArchiveFilters();
	initMcaArchiveFilters();
	initPostArchiveFilters();
}
// Run when Gravity Forms starts processing a submission.
document.addEventListener('gform/theme/scripts_loaded', () => {
	gform.addFilter('gform/submission/submission_started', (data) => {
		if (data.submissionType !== gform.submission.SUBMISSION_TYPE_SUBMIT) {
			return data;
		}
		const button = data.form.querySelector(
			'button.gform_button[type="submit"], input.gform_button[type="submit"]'
		);

		if (!button) {
			return data;
		}

		if (button.tagName === 'BUTTON') {
			button.textContent = 'Submitting…';
		} else {
			button.value = 'Submitting…';
		}

		button.disabled = true;

		return data;
	});
});